import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-lg overflow-hidden transition-all duration-200 hover:border-border2",
        className,
      )}
      {...props}
    />
  );
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4 sm:p-[18px]", className)} {...props} />;
}

export function SectionHeading({
  title,
  subtitle,
  action,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-3 mb-3">
      <div>
        <div className="font-display text-[15px] font-bold text-text">{title}</div>
        {subtitle && <div className="text-[11px] text-text3 mt-0.5">{subtitle}</div>}
      </div>
      {action}
    </div>
  );
}
